import { render } from "./ThemeManagement.vue?vue&type=template&id=043b78ee&ts=true"
import script from "./ThemeManagement.vue?vue&type=script&lang=ts"
export * from "./ThemeManagement.vue?vue&type=script&lang=ts"

import "./ThemeManagement.vue?vue&type=style&index=0&id=043b78ee&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__